import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=4313595f&scoped=true&"
import script from "./VerifyPage.vue?vue&type=script&lang=js&"
export * from "./VerifyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313595f",
  null
  
)

export default component.exports